import React from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps, navigate } from '@reach/router';

import messages from './Messages';
import Button from 'components/Button';
import image from 'assets/images/locked.png';

type IComponentProps = RouteComponentProps;

const AccessDenied: React.FC<IComponentProps> = () => {
  return (
    <article style={{ display: 'grid', justifyContent: 'center' }}>
      <Helmet>
        <title>{messages.accessDenied}</title>
        <meta name="description" content={messages.accessDenied} />
      </Helmet>
      <h5 style={{ textAlign: 'center', marginTop: '100px' }}>
        {messages.accessDeniedMessage}
      </h5>
      <img
        style={{ maxHeight: '80vp', maxWidth: '80vw', margin: 'auto' }}
        src={image}
        alt="locked"
      />
      <Button
        style={{ width: '150px', margin: 'auto' }}
        onClick={() => {
          navigate('/homepage');
        }}
        color={'green'}
      >
        {messages.home}
      </Button>
      <Button
        style={{ width: '150px', margin: 'auto' }}
        onClick={() => {
          navigate(
            `/logout?redirect=${
              window.location.pathname + window.location.search
            }`
          );
        }}
        color={'red'}
      >
        {messages.loginWithAnotherUser}
      </Button>
    </article>
  );
};

export default AccessDenied;
